var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralExtractRH = function SvgDAhuGeneralExtractRH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 605,
    cy: 168.1,
    rx: 11,
    ry: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,158.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S599.5,158.1,605,158.1 M605,157.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S611.1,157.1,605,157.1L605,157.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.4,168.2h-1.1v2.2h-1v-5.7h2c0.7,0,1.2,0.1,1.5,0.4c0.4,0.3,0.5,0.7,0.5,1.3c0,0.4-0.1,0.7-0.3,0.9 c-0.2,0.3-0.4,0.4-0.8,0.6l1.3,2.4v0.1h-1.1L602.4,168.2z M601.3,167.4h1c0.3,0,0.6-0.1,0.8-0.2s0.3-0.4,0.3-0.7 s-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.2-0.8-0.3h-1L601.3,167.4L601.3,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.8,170.4h-1v-2.5h-2.5v2.5h-1v-5.7h1v2.4h2.5v-2.4h1V170.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 604,
    y: 179,
    width: 2,
    height: 22
  })))));
};
export default SvgDAhuGeneralExtractRH;